import { contentfulImage } from '~/utils/contentful-image'

const imageSize = (size: number) => size * 2

export const personPhotoSrc = (photo: { url: string }, size: number) =>
  contentfulImage(photo.url, {
    fit: 'thumb',
    w: imageSize(size),
    h: imageSize(size),
  }) ?? ''
